// import axios from "axios";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import { Constants } from "../../../CommonMethhods/Constants";
import { DASHBOARD_CLIENT_DETAIL_EQUITY } from "../../../Configuration/API_URL";
import { AESEncryption, ApiResDecrypt, decryptData } from "../../../CommonMethhods/CommonMethods";
import PartnerAnalyticsStock from "./PartnerAnalyticsStock";
import PartnerAnalyticMarketCap from "./PartnerAnalyticMarketCap";
import PartnerAnalyticSector from "./PartnerAnalyticSector";

function PartnerAnalyticNew() {
  const storeToken = localStorage.getItem("ssoToken");
  const PartnerClientCode = localStorage.getItem("ClientId2");
  const [analyticData, setAnalyticsData] = useState();
  const [component, setComponent] = useState("sector");
  let clientCode = "";


  const getAnalyticsDataNew = async (clientCode) => {
    let payloadValue = { ClientCode: clientCode };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getAnalyticsDetails = await axios.post(
        DASHBOARD_CLIENT_DETAIL_EQUITY.Stock_Analytics_New_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getAnalyticsDetails?.data);
      // let decryptedRes = JSON.parse(res);
      
      if (res?.data) {
        setAnalyticsData(res?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (PartnerClientCode) {
      clientCode = PartnerClientCode;
      getAnalyticsDataNew(clientCode);
    }
    
  }, []);

  const handleOnChange = (e) => {
    if (e.target.value === "sector") {
      setComponent("sector");
    } else if (e.target.value === "stocks") {
      setComponent("stocks");
    } else {
      setComponent("marketcap");
    }
  };


  const accountDetailEquity = analyticData?.account[0].per;
  // const accountDetailDebt = analyticData?.account[1].per;
  console.log(accountDetailEquity, "accountDetailEquity");


  return (
    <div className="card-box analytics bottom-25">
      <div className="card-title">
        <h2 className="small-title">{Constants.Analytics}</h2>
      </div>
      <div className="head">
        <div className="leftHead">
          <div className="firstData">
            {Constants.Equity}: {accountDetailEquity}%
          </div>
        </div>
        <div className="rightHead">
          <div className="filter-options">
            {/* <!-- dropdown --> */}
            <div className="dropdown-filter displayFlex">
              <div className="dataRight">{Constants.view_allocation}</div>

              <Form.Select
                size="lg"
                aria-label="Default select example"
                onChange={handleOnChange}
              >
                <option value="sector">{Constants.Sector}</option>
                <option value="stocks">{Constants.Stocks}</option>
                <option value="marketcap">{Constants.Market_Cap}</option>
              </Form.Select>
            </div>
          </div>
        </div>
      </div>
      <div className="analytic-bottom">
        {component === "sector" ? (
          <PartnerAnalyticSector sector={analyticData?.sector} />
        ) : component === "marketcap" ? (
          <PartnerAnalyticMarketCap marketCap={analyticData?.marketCap} />
        ) : (
          <PartnerAnalyticsStock stock={analyticData?.company} />
        )}
      </div>
    </div>
  );
}

export default PartnerAnalyticNew;
